import { render, staticRenderFns } from "./announcement_config_permissions.vue?vue&type=template&id=29096b4e"
import script from "./announcement_config_permissions.vue?vue&type=script&lang=js"
export * from "./announcement_config_permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29096b4e')) {
      api.createRecord('29096b4e', component.options)
    } else {
      api.reload('29096b4e', component.options)
    }
    module.hot.accept("./announcement_config_permissions.vue?vue&type=template&id=29096b4e", function () {
      api.rerender('29096b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/announcement_config_permissions.vue"
export default component.exports